// import '../styles/globals.css'

// import '../styles/firebaseui-styling.global.css'; // Import globally.

// import React from 'react';
// import { debugL } from '../custom';


// doesn't work with node 18

// if (process.env.NODE_ENV === 'development' && debugL > 0) {
//   console.log('Initializing Why Did You Render');
//   const whyDidYouRender = require('@welldone-software/why-did-you-render');
//   whyDidYouRender(React, {
//     trackAllPureComponents: true,
//     logOnDifferentValues: true,
//     // trackExtraHooks: [
//     //   [require('react'), 'useState'],  // Track React's useState
//     //   [require('@welldone-software/why-did-you-render'), 'useState'],  // Track WDYR's useState
//     // ],
//     // // include: [/./], // Track all components
//     // notifier: (options) => {
//     //   if(options.displayName == "OrderCard") {
//     //     console.log(options);
//     //   }
//     // },
//   });
// }

// if (process.env.NODE_ENV === 'development') {
//   if (typeof window !== 'undefined') {
//     // eslint-disable-next-line @typescript-eslint/no-var-requires
//     const whyDidYouRender = require('@welldone-software/why-did-you-render');
//     whyDidYouRender(React, {
//       trackAllPureComponents: true
//     });
//   }
// }

function MyApp({ Component, pageProps }) {

  return (
      <div>
        {typeof window === 'undefined' ? null : <Component {...pageProps} />}
      </div>
  );

}

export default MyApp